import React from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import type { ExistingWeldSummary } from '../UploadWeldDataDialog'

interface ReuploadWarningBannerProps {
  existingSummary: ExistingWeldSummary
  /** Extra context when replacing a different upload format. */
  formatSwitchWarning?: string | null
}

export default function ReuploadWarningBanner({
  existingSummary,
  formatSwitchWarning
}: ReuploadWarningBannerProps) {
  const label =
    existingSummary.source === 'manual'
      ? 'manual weld parameters'
      : existingSummary.sourceFilename
        ? `uploaded data (${existingSummary.sourceFilename})`
        : 'uploaded weld data'

  return (
    <div
      role="alert"
      data-testid="reupload-warning-banner"
      className="flex gap-3 rounded-lg border border-warning-200 bg-warning-50 px-4 py-3 text-sm text-warning-800"
    >
      <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0 text-warning-600" aria-hidden />
      <div className="min-w-0">
        <p className="font-semibold">Existing data will be replaced</p>
        <p className="mt-1 text-[12px]">
          This weld already has {label}. Uploading again will replace it.
        </p>
        {formatSwitchWarning ? (
          <p className="mt-1 text-[12px] font-medium">{formatSwitchWarning}</p>
        ) : null}
      </div>
    </div>
  )
}
